"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpirationPeriod = exports.convertFromMsToDays = exports.convertFromUtcToLocal = exports.formatDate = exports.readableDate = void 0;
var moment_1 = __importDefault(require("moment"));
var GeneralSettings_1 = require("../constants/GeneralSettings");
var readableDate = function (date) {
    return moment_1.default(date).format(GeneralSettings_1.DATE_FORMAT.READABLE_DATE);
};
exports.readableDate = readableDate;
var formatDate = function (date) {
    //@TODO: Proper formatting needed, this should be based on current language
    return new Date(date).toLocaleDateString('en-US');
};
exports.formatDate = formatDate;
var convertFromUtcToLocal = function (date) {
    var offsetInMinutes = moment_1.default(date).utcOffset();
    var convertedDate = moment_1.default(date);
    convertedDate.subtract(offsetInMinutes, 'minutes');
    return convertedDate;
};
exports.convertFromUtcToLocal = convertFromUtcToLocal;
var convertFromMsToDays = function (value) {
    return value / (24 * 60 * 60 * 1000);
};
exports.convertFromMsToDays = convertFromMsToDays;
var getExpirationPeriod = function (endDate) {
    var now = moment_1.default();
    if (!endDate || moment_1.default(exports.convertFromUtcToLocal(endDate)) <= now) {
        return null;
    }
    var expiration = moment_1.default(exports.convertFromUtcToLocal(endDate));
    var diffDuration = moment_1.default.duration(expiration.diff(now));
    return {
        days: diffDuration.days(),
        hours: diffDuration.hours(),
        minutes: diffDuration.minutes(),
    };
};
exports.getExpirationPeriod = getExpirationPeriod;
